import { useState, useEffect } from "react";
import { IonRow, IonCol } from "@ionic/react";
import { SEO, PageTitle, Loading } from "../components";
import { useVideoData } from "../hooks/useVideoData";

export const Video = (props) => {
  const { config, project } = props;

  const [loading, setLoading] = useState(true);
  const sheetId = config?.googleSheetId;
  const data = useVideoData(sheetId);
  const seo = config?.SEO.videos;

  useEffect(() => {
    if (data && data.length > 0) {
      setLoading(false);
    }
  }, [data]);

  return (
    <div id="VideoPage" className="video-page">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />

      {loading ? (
        <Loading />
      ) : (
        <>
          <PageTitle pageTitle={"VIDEOS"} />
          <div className="flex-center">
            <IonRow className="video-container">
              {data &&
                data.map((video, index) => (
                  <IonCol size="auto" key={index} className="frame-col">
                    <iframe
                      className="shadow-img"
                      src={video?.src}
                      title={"YouTube video player"}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="eager"
                      decoding="async"
                      fetchpriority="auto"
                    />
                    &nbsp;
                    <p>{video?.name}</p>
                  </IonCol>
                ))}
            </IonRow>
          </div>
        </>
      )}
    </div>
  );
};
